import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-219b32c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "workshop" }
const _hoisted_2 = { class: "workshop__preload" }
const _hoisted_3 = ["src"]

import { onMounted } from 'vue';
import { useInfo, useWorkshop } from '@/store';
import { useImgSrc } from '../components/workshop/useWorkshopImg';

// components
import Playground from '@/components/workshop/Playground';
import Festival from '@/components/workshop/Festival';
import ShareView from '@/components/workshop/ShareView';

export default /*#__PURE__*/_defineComponent({
  __name: 'WorkShop',
  setup(__props) {

const { checkRoute } = useInfo();
const { getWorkshop } = useWorkshop();

const images = useImgSrc();
const imageSrcList = Object.values(images).reduce((acc: string[], curr) => {
  return [...acc, curr.pc, curr.tablet, curr.mobile];
}, []);
onMounted(async () => {
  await checkRoute('/event', getWorkshop);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Playground)),
    _createVNode(_unref(Festival)),
    _createVNode(_unref(ShareView)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imageSrcList), (item, index) => {
        return (_openBlock(), _createElementBlock("img", {
          key: index,
          src: item
        }, null, 8, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})